import { SVGIconProps } from './types'

export const BranchMergeIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46175 2.12457C9.64447 1.94119 9.64395 1.6444 9.46058 1.46166C9.27716 1.27892 8.98039 1.27945 8.79767 1.46283L7.47538 2.78979C7.23111 3.03553 7.08678 3.36211 7.06845 3.70638C7.06452 3.73075 7.0625 3.75573 7.0625 3.7812C7.0625 3.80666 7.06452 3.83165 7.06845 3.85601C7.08678 4.20028 7.23111 4.52687 7.47538 4.77261L8.79767 6.09959C8.98039 6.28296 9.27716 6.28348 9.46058 6.10076C9.64395 5.91799 9.64447 5.62123 9.46175 5.43785L8.27806 4.24995H9.21875C9.75153 4.24995 10.1229 4.25031 10.4121 4.27394C10.6957 4.29711 10.8587 4.34032 10.9822 4.40322C11.2468 4.53804 11.4619 4.75317 11.5967 5.01777C11.6596 5.14122 11.7028 5.30421 11.726 5.58785C11.7496 5.87703 11.75 6.24841 11.75 6.7812V9.92182C10.6802 10.139 9.875 11.0848 9.875 12.2187C9.875 13.5131 10.9243 14.5624 12.2188 14.5624C13.5132 14.5624 14.5625 13.5131 14.5625 12.2187C14.5625 11.0848 13.7573 10.139 12.6875 9.92182V6.76113C12.6875 6.2531 12.6875 5.84337 12.6604 5.51154C12.6325 5.16988 12.5735 4.86979 12.432 4.59216C12.2074 4.15115 11.8488 3.7926 11.4078 3.5679C11.1302 3.42644 10.8301 3.36746 10.4884 3.33955C10.1566 3.31244 9.74684 3.31244 9.23881 3.31245H8.27806L9.46175 2.12457ZM2.375 3.7812C2.375 3.00455 3.0046 2.37495 3.78125 2.37495C4.5579 2.37495 5.1875 3.00455 5.1875 3.7812C5.1875 4.55785 4.5579 5.18745 3.78125 5.18745C3.0046 5.18745 2.375 4.55785 2.375 3.7812ZM3.78125 1.43745C2.48683 1.43745 1.4375 2.48678 1.4375 3.7812C1.4375 4.91508 2.2427 5.8609 3.3125 6.07807V9.92182C2.2427 10.139 1.4375 11.0848 1.4375 12.2187C1.4375 13.5131 2.48683 14.5624 3.78125 14.5624C5.07567 14.5624 6.125 13.5131 6.125 12.2187C6.125 11.0848 5.31978 10.139 4.25 9.92182V6.07807C5.31978 5.8609 6.125 4.91508 6.125 3.7812C6.125 2.48678 5.07567 1.43745 3.78125 1.43745ZM2.375 12.2187C2.375 11.442 3.0046 10.8124 3.78125 10.8124C4.5579 10.8124 5.1875 11.442 5.1875 12.2187C5.1875 12.9954 4.5579 13.6249 3.78125 13.6249C3.0046 13.6249 2.375 12.9954 2.375 12.2187ZM12.218 10.8124C11.4417 10.8129 10.8125 11.4423 10.8125 12.2187C10.8125 12.9954 11.4421 13.6249 12.2188 13.6249C12.9954 13.6249 13.625 12.9954 13.625 12.2187C13.625 11.442 12.9954 10.8124 12.2188 10.8124H12.218Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const BranchIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5317 4.92867C12.1795 4.92867 12.7047 4.40393 12.7047 3.75663C12.7047 3.10933 12.1795 2.58459 11.5317 2.58459C10.8838 2.58459 10.3586 3.10933 10.3586 3.75663C10.3586 4.40393 10.8838 4.92867 11.5317 4.92867ZM11.5317 5.92579C12.7307 5.92579 13.7027 4.95463 13.7027 3.75663C13.7027 2.55863 12.7307 1.58746 11.5317 1.58746C10.3326 1.58746 9.36062 2.55863 9.36062 3.75663C9.36062 4.95463 10.3326 5.92579 11.5317 5.92579Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47111 13.7028C5.11897 13.7028 5.64417 13.1781 5.64417 12.5308C5.64417 11.8835 5.11897 11.3587 4.47111 11.3587C3.82325 11.3587 3.29805 11.8835 3.29805 12.5308C3.29805 13.1781 3.82325 13.7028 4.47111 13.7028ZM4.47111 14.7C5.67015 14.7 6.64217 13.7288 6.64217 12.5308C6.64217 11.3328 5.67015 10.3616 4.47111 10.3616C3.27207 10.3616 2.30005 11.3328 2.30005 12.5308C2.30005 13.7288 3.27207 14.7 4.47111 14.7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.97011 7.93009V11.3501H3.97211V7.93009H4.97011Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0307 5.33515V7.47328H11.0327V5.33515H12.0307Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0307 7.43153C12.0307 7.70688 11.8073 7.93009 11.5317 7.93009H4.5223C4.24671 7.93009 4.0233 7.70688 4.0233 7.43153C4.0233 7.15618 4.24671 6.93296 4.5223 6.93296H11.5317C11.8073 6.93296 12.0307 7.15618 12.0307 7.43153Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47111 2.19708C5.11898 2.19708 5.64418 2.72182 5.64418 3.36912C5.64418 4.01642 5.11898 4.54115 4.47111 4.54115C3.82325 4.54115 3.29805 4.01642 3.29805 3.36912C3.29805 2.72182 3.82325 2.19708 4.47111 2.19708ZM4.47111 1.19995C5.67016 1.19995 6.64217 2.17112 6.64217 3.36912C6.64217 4.56711 5.67016 5.53828 4.47111 5.53828C3.27207 5.53828 2.30005 4.56711 2.30005 3.36912C2.30005 2.17112 3.27207 1.19995 4.47111 1.19995Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.97011 7.96981V4.5498H3.97211V7.96981H4.97011Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const MergeIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.49861 10.2216L3.59779 14.1224C3.4915 14.2286 3.36115 14.2825 3.20677 14.284C3.05225 14.2854 2.91795 14.2291 2.80385 14.115C2.69756 14.0087 2.64441 13.8751 2.64441 13.7144C2.64441 13.5534 2.69756 13.4198 2.80385 13.3135L6.05079 10.0549C6.35969 9.74587 6.58232 9.43051 6.71867 9.10881C6.8549 8.78712 6.92301 8.40927 6.92301 7.97527V3.66271L5.89288 4.69302C5.78659 4.79919 5.65619 4.85227 5.50167 4.85227C5.34728 4.85227 5.21298 4.79522 5.09875 4.68113C4.99259 4.57484 4.9395 4.4413 4.9395 4.28051C4.9395 4.1196 4.99259 3.986 5.09875 3.87971L7.013 1.95817C7.15178 1.81939 7.31365 1.75 7.49861 1.75C7.68357 1.75 7.84544 1.81939 7.98422 1.95817L9.90575 3.87971C10.012 3.986 10.0672 4.1164 10.0711 4.27092C10.075 4.42531 10.0198 4.55961 9.90575 4.67384C9.79946 4.78 9.66592 4.83309 9.50514 4.83309C9.34423 4.83309 9.21062 4.78 9.10433 4.67384L8.0742 3.66271V7.97527C8.0742 8.40927 8.14481 8.78955 8.28602 9.1161C8.42724 9.44278 8.65229 9.76064 8.9612 10.0697L12.2008 13.321C12.307 13.4273 12.3621 13.5577 12.366 13.712C12.37 13.8666 12.3149 14.0009 12.2008 14.115C12.0946 14.2213 11.961 14.2744 11.8 14.2744C11.6393 14.2744 11.5057 14.2213 11.3994 14.115L7.49861 10.2216Z"
        fill="currentColor"
      />
    </svg>
  )
}
